(function () {
  if (window.RutsCollectionsCarousel) {
    window.RutsCollectionsCarousel.init();
    return;
  }

  function getSlideStep(track) {
    var firstSlide = track.querySelector('[data-carousel-slide]');
    if (!firstSlide) return track.clientWidth;
    var trackStyle = window.getComputedStyle(track);
    var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
    return firstSlide.getBoundingClientRect().width + gap;
  }

  function activeIndex(track) {
    var step = getSlideStep(track);
    if (step <= 0) return 0;
    return Math.round(track.scrollLeft / step);
  }

  function refresh(track, prevBtn, nextBtn, dots) {
    var scrollLeft = track.scrollLeft;
    var maxScroll = track.scrollWidth - track.clientWidth;
    var epsilon = 1;

    if (prevBtn) prevBtn.disabled = scrollLeft <= epsilon;
    if (nextBtn) nextBtn.disabled = maxScroll <= epsilon || scrollLeft >= maxScroll - epsilon;

    if (dots && dots.length) {
      var idx = activeIndex(track);
      if (idx < 0) idx = 0;
      if (idx > dots.length - 1) idx = dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        var isOn = i === idx;
        dots[i].classList.toggle('is-active', isOn);
        if (isOn) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }
  }

  function initCarousel(root) {
    if (!root || root.dataset.rutsCarouselInit === 'true') return;

    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    root.dataset.rutsCarouselInit = 'true';

    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var dots = root.querySelectorAll('[data-carousel-dot]');

    function update() {
      refresh(track, prevBtn, nextBtn, dots);
    }

    function scrollByStep(direction) {
      track.scrollBy({ left: direction * getSlideStep(track), behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    for (var i = 0; i < dots.length; i++) {
      (function (dot) {
        dot.addEventListener('click', function () {
          var slides = track.querySelectorAll('[data-carousel-slide]');
          var target = slides[parseInt(dot.getAttribute('data-index'), 10)];
          if (target) {
            track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          }
        });
      })(dots[i]);
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
  }

  function initAll(scope) {
    var scopeEl = scope && scope.querySelectorAll ? scope : document;
    var roots = scopeEl.querySelectorAll('[data-ruts-carousel]');
    for (var i = 0; i < roots.length; i++) {
      initCarousel(roots[i]);
    }
  }

  window.RutsCollectionsCarousel = { init: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });
})();
